import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { SnakeLadderGameCoreService } from './snake-ladder-game-core.service';
import { SnakeLadderGameSelectorComponent } from './snake-ladder-game-selector/snake-ladder-game-selector.component';

@NgModule({
  declarations: [SnakeLadderGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [SnakeLadderGameCoreService],
  exports: [SnakeLadderGameSelectorComponent],
})
export class SnakeLadderGameCoreModule {}
